import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import LargeScreenList from './largeScreen/LargeScreenList';
import SmallScreenList from './smallScreen/SmallScreenList';
import { Link } from '~COMPONENTS/';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const headerStyle = 'headline-5 p5-sm prl3-lg pt4-lg pb4-lg d-sm-b';

const NavListCopy = ({ section, disabled }) => (
  <h3 className={classnames(headerStyle, 'navigation__header', disabled ? 'text-color-warm-grey' : '')}>
    {' '}
    <TranslatedCopy id={section} />{' '}
  </h3>
);

NavListCopy.propTypes = {
  section: PropTypes.any.isRequired,
  disabled: PropTypes.bool.isRequired
};

const NavList = ({ routes, toggleNavMenu, canAccessInvoices }) => (
  <nav className='nav'>
    {Object.keys(routes).map(link => {
      const parentRoute = routes[link];
      return (
        <Fragment key={`${parentRoute.section}-nav`}>
          <span className={!parentRoute.disableLink ? 'navigation__headerWrap' : ''}>
            {parentRoute.hideLink || parentRoute.disableLink ? (
              <div
                className='navigation__sectionHeader'
                data-desc={`navList__link_${parentRoute.to}`}
                style={{ cursor: 'pointer' }}
              >
                <NavListCopy section={parentRoute.section} disabled={parentRoute.disableLink} />
              </div>
            ) : (
              <Link
                to={parentRoute.to}
                className='navigation__sectionHeader'
                data-desc={`navList__link_${parentRoute.to}`}
              >
                <NavListCopy section={parentRoute.section} />
              </Link>
            )}

            {parentRoute.routes && (
              <LargeScreenList
                routes={parentRoute.routes}
                isOrders={parentRoute.to === '/orders'}
                canAccessInvoices={canAccessInvoices}
              />
            )}
          </span>
          {parentRoute.routes && (
            <SmallScreenList
              routes={parentRoute.routes}
              toggleNavMenu={toggleNavMenu}
              isOrders={parentRoute.to === '/orders'}
            />
          )}
        </Fragment>
      );
    })}
    <div className='navigation__sectionHeader d-lg-h'>
      <h3 className={classnames(headerStyle, 'p5-sm pb0-lg navigation__header')}>
        <TranslatedCopy id='route.user.section' />
      </h3>
    </div>
    <ul className='navigation__list'>
      <li>
        <Link
          to={`${import.meta.env.VITE_HELP_GUIDE_URL}`}
          extraClassName='body-4 u-bold bg-secondary-grey border-bottom d-sm-b prl5-sm pt4-sm pb4-sm'
          data-desc='help__link'
          external
        >
          <TranslatedCopy id='nav.help.user' />
        </Link>
      </li>
      <li>
        <Link
          to='/contact-us'
          extraClassName='body-4 u-bold bg-secondary-grey border-bottom d-sm-b prl5-sm pt4-sm pb4-sm'
          data-desc='contactUs__link'
          onClick={toggleNavMenu}
        >
          <TranslatedCopy id='global.contact' />
        </Link>
      </li>
    </ul>
  </nav>
);

NavList.defaultProps = {
  routes: null
};

const routeTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
    PropTypes.object // redux form
  ]),
  exact: PropTypes.bool,
  nav: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string,
  section: PropTypes.string,
  to: PropTypes.string,
  link: PropTypes.string,
  hideLink: PropTypes.bool,
  disableLink: PropTypes.bool
};

const routesTypes = {
  ...routeTypes,
  routes: PropTypes.arrayOf(PropTypes.shape(routeTypes))
};

NavList.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape(routesTypes)),
  toggleNavMenu: PropTypes.func.isRequired,
  canAccessInvoices: PropTypes.bool.isRequired
};

export default NavList;
